<template>
    <el-row>
        <el-form label-width="120px"  ref="SampleInfo" :model="SampleInfo">
            <h4>目标化合物信息:</h4>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="结构式名称:" prop="TargetName">
                        <el-input size="mini" v-model="SampleInfo.TargetName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="CAS:" prop="CAS">
                        <el-input size="mini" v-model="SampleInfo.CAS"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="结构式:" :required="true">
                        <el-button type="primary" size="mini" @click="openTarget">上传</el-button>
                        <el-dialog 
                         :visible.sync="dialogVisible"
                         :close-on-click-modal="false"
                         :append-to-body="true"
                          v-loading="onLoading"
                          custom-class="dialog"
                         >
                         <iframe
                            style="display:'block',margin:'0 auto'"
                            id="ifKetcher"
                            name='molview'
                            width=784
                            height=624
                            src='./iframe/index.html'
                            :onload="onloaded()"
                            ></iframe>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="uploadTarget">确 定</el-button>
                        </div>
                        </el-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <div v-if="SampleInfo.TargetPic!=''"><img :src="'data:image/png;base64,'+SampleInfo.TargetPic" class="imgUrl"></div>
                </el-col>
            </el-row>
            <h4>起始化合物信息:</h4>
            <el-row :gutter="20" v-for="(startObject, index) in startObjects" :key="index">
                <el-col :span="6">
                    <el-form-item label="结构式名称: ">
                        <el-input size="mini" v-model="startObject.name"></el-input>

                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="CAS:">
                        <el-input size="mini" v-model="startObject.cas"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="结构式:">
                        <el-button type="primary" size="mini" @click="() =>openStart(index)">上传</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <div v-if="startObjects[index].png!=''"><img :src="'data:image/png;base64,'+startObjects[index].png" class="imgUrl"></div>
                </el-col>
            </el-row>
            <el-row style="text-align: center">
                <el-button type="text" @click="popStartCompound" v-if="startObjects.length>1" style="margin-right: 100px">删除上一条化合物</el-button>
                <el-button type="text" @click="addNewStartCompound">添加新化合物</el-button>
            </el-row>
        </el-form>
        <el-dialog 
        :visible.sync="dialogStartVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
        v-loading="onLoading"
        custom-class="dialog"
        >
        <iframe
        style="display:'block',margin:'0 auto'"
        id="ifKetcherStart"
        name='molview'
        width=784
        height=624
        src='./iframe/index.html'
        :onload="onstartloaded()"
        ></iframe>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogStartVisible = false">取 消</el-button>
        <el-button type="primary" @click="() =>uploadStart(startIndex)">确 定</el-button>
    </div>
    </el-dialog>
    </el-row>
    
</template>

<script>
    import { mapActions} from 'vuex'
    export default {
        name: "InputOriginSampleInfo",
        data() {
            return {
                startIndex:0,
                dialogVisible: false,
                dialogStartVisible:false,
                username: this.$store.state.username,
                onLoading: false,
                uploadFileString:"",
                /**
                 * 2. 目标化合物信息
                 * */
                SampleInfo: {
                    CAS: "",
                    Project: "",
                    TargetSmiles: "",
                    TargetMolfile: "",
                    TargetStructure: "",
                    TargetName: "",
                    TargetPic: "",
                    ReactantList: []
                },
                /**
                 * 2. 起始化合物信息
                 * */
                startObjects: [{
                    name: '',
                    png: '',
                    cas: '',
                    smile:''
                }],
                targetPngs: [],
                startPngs: []

            }
        },
        methods: {
            onloaded:function(){         
            },
            async uploadTarget (){
            try {
                let ketcherFrame = document.getElementById('ifKetcher')
                let ketcher = ketcherFrame.contentWindow.ketcher

                let smile = await ketcher.getSmiles()
                let origin_image = await ketcher.generateImage(smile,{
                                            outputFormat: "png",                        // 生成图片的类型，可以是"svg"或"png"
                                            backgroundColor: "255, 255, 255"
                                    })
                 let url = URL.createObjectURL(origin_image)
                 let image = document.createElement('img')
                 image.src = url
                 image.onload = ()=> {
                            let w = image.width
                            let h = image.height
                            let w1 = Number((image.height / 7 * 12).toFixed(0))
                            let h1 = Number((image.width / 12 * 7).toFixed(0))
                            let canvas_w = Math.max(w, w1)
                            let canvas_h = Math.max(h, h1)
                            const canvas = document.createElement('canvas')
                            const ctx = canvas.getContext('2d')
                            canvas.width = canvas_w
                            canvas.height = canvas_h
                            ctx.fillStyle = '#ffffff'
                            ctx.fillRect(0, 0, canvas_w, canvas_h)
                            ctx.drawImage(image, (canvas_w - w) / 2, (canvas_h - h) / 2, w, h)
                            let png = canvas.toDataURL('image/png')
                            let imageUrl = png
                            imageUrl=imageUrl.substring(imageUrl.indexOf(',') + 1).replaceAll(" ", '+')
                            this.SampleInfo.TargetSmiles=smile
                            if(smile==""){
                                this.SampleInfo.TargetPic=""
                            }else{
                                 this.SampleInfo.TargetPic=imageUrl
                            }
                            this.dialogVisible=false
                        }
               
            } catch (e) {
            //   message.error({content:'Error'})
            //   setLoading(false)
            }
            },
            onstartloaded:function(){
            },
            async uploadStart (startIndex){
                console.log('uploadStart',startIndex)
            try {
                let ketcherFrame = document.getElementById('ifKetcherStart')
                let ketcher = ketcherFrame.contentWindow.ketcher

                let smile = await ketcher.getSmiles()
                let origin_image = await ketcher.generateImage(smile,{
                                            outputFormat: "png",                        // 生成图片的类型，可以是"svg"或"png"
                                            backgroundColor: "255, 255, 255"
                                    })
                 let url = URL.createObjectURL(origin_image)
                 let image = document.createElement('img')
                 image.src = url
                 image.onload = ()=> {
                            let w = image.width
                            let h = image.height
                            let w1 = Number((image.height / 7 * 12).toFixed(0))
                            let h1 = Number((image.width / 12 * 7).toFixed(0))
                            let canvas_w = Math.max(w, w1)
                            let canvas_h = Math.max(h, h1)
                            const canvas = document.createElement('canvas')
                            const ctx = canvas.getContext('2d')
                            canvas.width = canvas_w
                            canvas.height = canvas_h
                            ctx.fillStyle = '#ffffff'
                            ctx.fillRect(0, 0, canvas_w, canvas_h)
                            ctx.drawImage(image, (canvas_w - w) / 2, (canvas_h - h) / 2, w, h)
                            let png = canvas.toDataURL('image/png')
                            let imgUrlStart = png
                            imgUrlStart=imgUrlStart.substring(imgUrlStart.indexOf(',') + 1).replaceAll(" ", '+')
                            // console.log(smile,imgUrlStart)
                            // this.SampleInfo.TargetSmiles=smile
                            // this.SampleInfo.TargetPic=imageUrl
                            // this.startUrl=imgUrlStart
                            this.startObjects[startIndex].png=imgUrlStart
                            this.startObjects[startIndex].smile=smile
                            console.log(startIndex, this.startObjects)
                            this.dialogStartVisible=false
                        }
               
            } catch (e) {
            //   message.error({content:'Error'})
            //   setLoading(false)
            }
            },
            openTarget(){
                this.dialogVisible=true
                this.onLoading = true 
                setTimeout(()=>{
                  this.onLoading = false
                },2000)
            },
            openStart(index){
                this.startIndex=index
                this.dialogStartVisible=true
                this.onLoading = true 
                setTimeout(()=>{
                  this.onLoading = false
                },2000)
            },
            // 图片转Base64
            getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                let imgBase64 = '';
                reader.readAsDataURL(file);
                reader.onload = () => {
                imgBase64 = reader.result;
                };
                reader.onerror = error => reject(error);
                reader.onloadend = () => resolve(imgBase64);
            });
            },
                readySubmitFile(fileList) {//将准备提交的多张图片转为base64
                let _this = this;
                if (!(fileList instanceof Array) || fileList.length <= 0) {
                    return false;
                }
                _this.fileMessage.fileNameArr = [];
                _this.fileMessage.fileBase64Arr = [];
                for (let i = 0; i < fileList.length; i++) {
                    _this.fileMessage.fileNameArr.push(fileList[i].name);
                    _this.getBase64(fileList[i].raw).then(
                    (res) => {
                        console.log('222',res);
                        _this.fileMessage.fileBase64Arr.push(res);
                    },
                    (err) => {
                        console.log(err, "转码失败");
                    }
                    );
                }
                return true;
                },
            // 文件状态改变时的钩子
            changeFile(file, fileList) {
            fileList.forEach(async item => {
                const img = await this.getBase64(item.raw);
                this.SampleInfo.TargetPic=img
            });
            },
            
            submitForm() {
                this.$refs['SampleInfo'].validate((valid) => {
                if (valid) {
                    this.$store.commit('updateSampleInfo', true)
                } else {
                    this.$store.commit('updateSampleInfo', false)
                }
                });
                return
            },
            resetForm(){
                this.$refs['SampleInfo'].resetFields()
                this.SampleInfo.TargetPic=''
                this.SampleInfo.TargetName=''
                this.SampleInfo.CAS=''
                this.startObjects=[{
                                    cas:"",
                                    name:"",
                                    png:"",
                                    smile:""
                                }]
            },
            /**
             * 目标化合物图片函数
             * */
            // HttpPicUpload: function(param) {
            //     let formData = new FormData();
            //     formData.append('file', param.file);
            //     formData.set('username', this.$store.state.userId);
            //     formData.set('compoundsId', '');
            //     let _this = this;
            //     this.onLoading = true;

            //     this.$api.filePost('/datacenter/saveCompoundsFiles', formData, (res) => {
            //         this.onLoading = false;
            //         if (res.data.code == 200) {
            //             let fileVo = res.data.data[0];
            //             _this.SampleInfo.TargetPic = fileVo.path;
            //         } 
            //     })
            // },
            // onTargetPicUploadSuccess: function(res,file) {
            //     console.log('success',res,file)
            //     // // if (res.code == 200) {
            //     //     // let fileVo = res.data[0];
            //     //     // this.SampleInfo.TargetPic = fileVo.path;
            //     //     this.targetPngs = [img]
            //     //     this.SampleInfo.TargetPic = img
            //     // // } 
            // },

            // PicUploadChange: function(file, fileList) {
            //     // console.log('monitor files');
            //     this.targetPngs = fileList;
            //     // console.log(this.targetPngs);
            // },
            beforePicRemove: function(file, fileList) {
                this.targetPngs = fileList;
                if (this.targetPngs.length === 0 ) {
                    this.SampleInfo.TargetPic = ''
                }
            },
            onStartCompPicUploadSuccess: function(index,res,file) {
            //   debugger;
              if (res.code == 200) {
                  let fileVo = res.data[0];
                  this.startObjects[index].png = fileVo.path;
                  this.startPngs[index] = [file]
              }
            //   console.log(this.startObjects[index]);
            //   console.log(this.startPngs[index])
            },
            beforeStartCompPicRemove: function(file, fileList, index) {
                // console.log('monitor files');
                this.startPngs[index] = fileList;
                if (fileList.length == 0) {
                    this.startObjects[index].png = ''
                }
                // console.log(this.targetPngs);
            },
            /** 删除上一条起始化合物 */
            popStartCompound:function(){
               if (this.startObjects.length >1) {
                    this.startObjects.pop()
                    this.startPngs.pop()
                }
            },
            /**
             * 添加新的起始化合物
             * */
            addNewStartCompound: function() {
                if (this.startObjects.length < 10) {
                    this.startObjects.push({
                        name: '',
                        png: '',
                        cas: '',
                        smile:''
                    })
                    this.startPngs.push('')
                }
                
            },
            ...mapActions('sepaMethods', ['updateSampleInfo', 'updateStartObjects'])
        },
        created() {
          this.SampleInfo = this.$store.state.sepaMethods.SampleInfo;
          if (this.SampleInfo.TargetPic != '' && this.SampleInfo.TargetPic != undefined) {
              this.targetPngs = [{name:this.SampleInfo.TargetPic, url:this.SampleInfo.TargetPic}];
          }

          this.startObjects = this.$store.state.sepaMethods.startObjects;
          let _this = this;
          this.startObjects.forEach(so => {
              if (so.png != '' && so.png != undefined) {
                  _this.startPngs.push([{name: so.png, url: so.png}])
              }
          })
        },
        watch: {
            'SampleInfo': {
                handler() {
                    this.updateSampleInfo(this.SampleInfo);
                },
                deep: true
            },
            'startObjects' : {
                handler() {
                    this.updateStartObjects(this.startObjects);
                },
                deep: true
            }

        }
    }

</script>

<style scoped>
    @import '../../../assets/position-adjust.css';
    @import '../../../assets/border-style.css';
    
::v-deep .dialog {
  width:850px !important; 
  height: 800px !important;;
}
.imgUrl{
    width: 120px;
    height: 65px;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    padding: 3px 3px 3px 3px;
}
</style>